import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Apollographql = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.372 0 0 5.373 0 12c0 6.628 5.372 12 12 12 6.627 0 12-5.372 12-12a12.014 12.014 0 00-.473-3.343.6.6 0 00-1.127.409h-.002c.265.943.402 1.928.402 2.934a10.73 10.73 0 01-3.163 7.637A10.729 10.729 0 0112 22.8a10.73 10.73 0 01-7.637-3.163A10.728 10.728 0 011.2 12a10.73 10.73 0 013.163-7.637A10.728 10.728 0 0112 1.2c2.576 0 5.013.896 6.958 2.54a1.466 1.466 0 10.862-.84A11.953 11.953 0 0012 0zm-1.44 5.88l-4.2 10.902h2.63l.687-1.848h3.969l-.719-2.042h-2.613l1.7-4.691 3.024 8.58h2.631L13.47 5.88z"
  }));
});
Apollographql.displayName = 'Apollographql';
export var ApollographqlDimensions = {
  height: 24,
  width: 24
};